import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/components/floating-buttons/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProgressProvider"] */ "/app/src/modules/layout/components/progress-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/components/smartlook-wrapper/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/layout/components/version-tag.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/overright.css");
